import React from 'react';
import { SiteMember } from '../../components/ChatCreation/ChatCreation';
import socialServerApi from '../../services/socialServerApi';
import { Subtract } from 'utility-types';
import * as biLogger from '../../services/biLogger';

export interface WithMemberSearchInjectedProps {
  members: SiteMember[];
  loadingMembers: boolean;
  searchTerm?: string;
  onMemberSearch(searchTerm?: string): any;
  onFetchMore(): any;
}

interface WithMemberSearchState {
  members: SiteMember[];
  loadingMembers: boolean;
  searchTerm?: string;
  nextStartIndex?: number;
}

export const withMemberSearch = <P extends WithMemberSearchInjectedProps>(
  Component: React.ComponentType<P>,
): React.ComponentType<Subtract<P, WithMemberSearchInjectedProps>> =>
  class extends React.Component<
    Subtract<P, WithMemberSearchInjectedProps>,
    WithMemberSearchState
  > {
    numberOfMembers;
    constructor(props) {
      super(props);
      this.state = {
        members: [],
        loadingMembers: true,
        nextStartIndex: 0,
      };
      this.numberOfMembers = -1;
    }

    async componentDidMount() {
      const {
        members,
        nextPage: nextStartIndex,
      } = await socialServerApi.getMembers(0);
      this.setState({ members, loadingMembers: false, nextStartIndex });
    }

    memberSearchHandler = async (searchTerm: string) => {
      const { members, nextPage } = await socialServerApi.getMembers(
        0,
        searchTerm.trim(),
      );
      if (members.length !== this.numberOfMembers) {
        this.numberOfMembers = members.length;
        biLogger.socialSearchResults(this.numberOfMembers);
      }
      this.setState({ members, searchTerm, nextStartIndex: nextPage });
    };

    handleFetchMore = async () => {
      const { searchTerm, nextStartIndex } = this.state;
      if (nextStartIndex) {
        const { members, nextPage } = await socialServerApi.getMembers(
          nextStartIndex,
          searchTerm && searchTerm.trim(),
        );
        const concatMembers = [...this.state.members, ...members];
        this.setState({ members: concatMembers, nextStartIndex: nextPage });
      }
    };

    render() {
      const { members, loadingMembers, searchTerm } = this.state;

      const injectedProps = {
        members,
        loadingMembers,
        onMemberSearch: this.memberSearchHandler,
        searchTerm,
        onFetchMore: this.handleFetchMore,
        ...this.props,
      } as P;

      return <Component {...injectedProps} />;
    }
  };
